import {
    MapperDefinition,
    MapperExplicit,
} from '@services/mapper.service';
import {
    serializeDates,
    toDate,
} from '@utils/object.utils';

const isInMap = <T>(data: MapperExplicit<T>) =>
    typeof data === 'object' &&
    typeof data.in === 'function';

const isOutMap = <T>(data: MapperExplicit<T>) =>
    typeof data === 'object' &&
    typeof data.out === 'function';

export class Mapper<T> {
    public mapper: MapperDefinition<T> = {} as MapperDefinition<T>;

    protected _toDto = (data: any, nestedMapper?: any, source?: any): T => {
        const mapped: T = {} as T;
        const map = nestedMapper || this.mapper;
        source = source || data || {};

        for (const key of Object.keys(map)) {
            const mapKey = map[key];
            if (mapKey instanceof Array) { // map nested array
                const property = mapKey[0];
                const nestedData = data[property];
                if (nestedData instanceof Array) {
                    (mapped as any)[key] = [];
                    for (const entry of nestedData) {
                        if (entry) {
                            (mapped as any)[key].push(this._toDto(entry, mapKey[1], source));
                        }
                    }
                } else {
                    // map nested object
                    (mapped as any)[key] = nestedData ? this._toDto(nestedData, mapKey[1], source) : undefined;
                }
            } else if (typeof mapKey === 'function') {
                (mapped as any)[key] = mapKey(mapped, source);
            } else if (isInMap(mapKey)) {
                if (Array.isArray(mapKey.property)) {
                    (mapped as any)[key] = mapKey.in(data, mapped, source);
                } else {
                    (mapped as any)[key] = mapKey.in(data[mapKey.property], mapped, source);
                }
            } else {
                // map property
                (mapped as any)[key] = data[mapKey.property || mapKey];
            }
        }

        return toDate(mapped);
    }

    protected _toPoco = (data: any, nestedMapper?: any): any => {
        const serverData: any = {};
        const map = nestedMapper || this.mapper;
        for (const key of Object.keys(map)) {
            const mapKey = map[key];
            if (mapKey instanceof Array) { // map nested array
                const property = mapKey[0];
                const nestedData = data[key];
                if (nestedData instanceof Array) {
                    serverData[property] = [];
                    for (const entry of nestedData) {
                        if (entry) {
                            serverData[property].push(this._toPoco(entry, mapKey[1]));
                        }
                    }
                } else { // map nested object
                    serverData[property] = nestedData ? this._toPoco(nestedData, mapKey[1]) : undefined;
                }
            } else if (isOutMap(mapKey)) {
                const config: MapperExplicit<T> = mapKey;
                if (!Array.isArray(config.property)) {
                    serverData[config.property] = !config.out ?
                        data[key] :
                        config.out(data);
                } else {
                    // we expect here to have all the properties provided by the out function
                    const mapped = config.out && config.out(data);
                    config.property.forEach(mappedSubKey => {
                        if (mapped && mapped[mappedSubKey] != null) {
                            serverData[mappedSubKey] = mapped[mappedSubKey];
                        }
                    });
                }
            } else if (typeof mapKey === 'string') { // map property
                serverData[mapKey] = data[key];
            }
        }
        return serializeDates(serverData);
    }
}
